import axios from 'axios'
export default {
  findThirdBlockList (params) {
    return axios.post('/api/rendering/admin/front/user/copyright/findThirdBlockList', params)
  },
  statBlockStorageInfo(params) {
    return axios.post('/api/rendering/admin/front/user/copyright/statBlockStorageInfo', params)
  },
}
